import { BaseEntity } from "./BaseEntity";
import Channel from "./Channel";

export default class Department extends BaseEntity {

	constructor(id: number, public name: string) {
		super(id);
	}

}